import { useEffect, useState } from 'react';
import { obtenerEmpresas, obtenerCentros } from '../services/empresasService';

export const useEmpresas = (empresaId) => {
  const [empresas, setEmpresas] = useState([]);
  const [centros, setCentros] = useState([]);
  const [cargandoCentros, setCargandoCentros] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const cargarEmpresas = async () => {
      try {
        const data = await obtenerEmpresas();
        setEmpresas(data);
      } catch (error) {
        console.error('Error cargando empresas', error);
        setError('Error cargando empresas');
      }
    }

    cargarEmpresas();
  }, []);

  useEffect(() => {
    if (!empresaId) {
      setCentros([]);
      return;
    }

    const cargarCentros = async () => {
      try {
        setCargandoCentros(true);

        const data = await obtenerCentros(empresaId);
        setCentros(data);
      } 
      
      catch (error) {
        console.error('Error cargando centros de costo', error);
        setError('Error cargando centros de costo');
      }

      finally {
        setCargandoCentros(false);
      }
    };

    cargarCentros();

  }, [empresaId]);

  return {
    empresas, centros, cargandoCentros, error
  };
};